/* Premier Courses — course finder destinations.
   Single source of truth for where every state/stage/role path lands.
   Consumed by pc-statepicker.js (hero wizard) and pc-pricing.js (guided
   pricing wizard); loaded ahead of both by hero.liquid / pricing-cards.liquid.
   Keys are `STATE-stage-role`. Keep in sync with the header/footer nav links. */
window.PCRoutes = window.PCRoutes || {
  'CA-pre-agent': '/pages/california-real-estate-agent-pre-licensing',
  'FL-pre-agent': '/pages/florida-real-estate-agent-pre-licensing-education',
  'FL-pre-broker': '/pages/florida-real-estate-broker-pre-licensing-education',
  'FL-post-agent': '/pages/florida-real-estate-agent-post-licensing-education',
  'FL-post-broker': '/pages/florida-real-estate-broker-post-licensing-education',
  'FL-ce-agent': '/pages/florida-real-estate-agent-continuing-education',
  'FL-ce-broker': '/pages/florida-real-estate-broker-continuing-education',
  'FL-react-agent': '/pages/florida-real-estate-agent-reactivation-education',
  'FL-react-broker': '/pages/florida-real-estate-broker-reactivation-education',
  'CA-exam-agent': '/pages/california-real-estate-agent-exam-prep',
  'CA-exam-broker': '/pages/california-real-estate-broker-exam-prep',
  'FL-exam-agent': '/pages/florida-real-estate-agent-exam-prep',
  'FL-exam-broker': '/pages/florida-real-estate-broker-exam-prep'
};
